import { Component } from '@angular/core';
import { StatisticService } from 'app/shared/services/statistic.service';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';

@Component({
  selector: 'calendar-progress',
  template: `
    <div class="calendar-wrapper">
      <div class="menu">
        <p class="month-text">{{ currentMonth }}</p>
        <div class="buttons">
          <svg
            width="34"
            height="30"
            viewBox="0 0 34 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            (click)="previousMonth()"
          >
            <g filter="url(#filter0_d_314_1105)">
              <rect x="4" y="2" width="26" height="22" rx="8" fill="white" shape-rendering="crispEdges" />
              <path
                d="M22 13.75C22.4142 13.75 22.75 13.4142 22.75 13C22.75 12.5858 22.4142 12.25 22 12.25V13.75ZM11.4697 12.4697C11.1768 12.7626 11.1768 13.2374 11.4697 13.5303L16.2426 18.3033C16.5355 18.5962 17.0104 18.5962 17.3033 18.3033C17.5962 18.0104 17.5962 17.5355 17.3033 17.2426L13.0607 13L17.3033 8.75736C17.5962 8.46447 17.5962 7.98959 17.3033 7.6967C17.0104 7.40381 16.5355 7.40381 16.2426 7.6967L11.4697 12.4697ZM22 12.25L12 12.25V13.75L22 13.75V12.25Z"
                fill="black"
              />
            </g>
            <defs>
              <filter
                id="filter0_d_314_1105"
                x="0"
                y="0"
                width="34"
                height="30"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_314_1105" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_314_1105" result="shape" />
              </filter>
            </defs>
          </svg>

          <svg
            width="34"
            height="30"
            viewBox="0 0 34 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            (click)="nextMonth()"
          >
            <g filter="url(#filter0_d_314_1107)">
              <rect x="4" y="2" width="26" height="22" rx="8" fill="white" shape-rendering="crispEdges" />
              <path
                d="M12 12.25C11.5858 12.25 11.25 12.5858 11.25 13C11.25 13.4142 11.5858 13.75 12 13.75V12.25ZM22.5303 13.5303C22.8232 13.2374 22.8232 12.7626 22.5303 12.4697L17.7574 7.6967C17.4645 7.40381 16.9896 7.40381 16.6967 7.6967C16.4038 7.98959 16.4038 8.46447 16.6967 8.75736L20.9393 13L16.6967 17.2426C16.4038 17.5355 16.4038 18.0104 16.6967 18.3033C16.9896 18.5962 17.4645 18.5962 17.7574 18.3033L22.5303 13.5303ZM12 13.75L22 13.75V12.25L12 12.25V13.75Z"
                fill="black"
              />
            </g>
            <defs>
              <filter
                id="filter0_d_314_1107"
                x="0"
                y="0"
                width="34"
                height="30"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_314_1107" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_314_1107" result="shape" />
              </filter>
            </defs>
          </svg>
        </div>
      </div>
      <div class="calendar">
        <div class="empty-day" *ngFor="let _ of emptyDays"></div>
        <div *ngFor="let day of days" class="day">
          <div class="circle">
            <calender-progress-bar [progress]="getProgressForDay(day) * 16.67" color="#E6A43D"></calender-progress-bar>
            <span class="day-number">{{ day }}</span>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      .calendar-wrapper {
        margin-bottom: 20px;
      }

      .calendar {
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        gap: 5px;
      }

      .menu {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .month-text {
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 25px;
      }

      .empty-day {
        width: calc((100% / 7) * 2); /* Breite der ersten beiden leeren Tage */
      }

      .day {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .circle {
        position: relative;
      }

      .day-number {
        position: absolute;
        top: -10px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 14px;
      }

      .buttons {
        margin-left: auto;
        margin-bottom: 25px;
      }
    `,
  ],
})
export class CalendarActivityComponent {
  days: number[] = [];
  currentMonth: string = '';
  emptyDays: number[] = [];

  dataMonth = [];

  constructor(
    private statsService: StatisticService,
    private translateService: TranslateService
  ) {
    this.updateCurrentMonth();
    this.getStatDataForMonth(this.currentMonth);
  }

  getProgressForDay(day: number) {
    if (this.dataMonth.length == 0) {
      return 0;
    }
    const result = this.dataMonth.find((item) => item.name == day.toString());

    if (!result) {
      return 0;
    }
    return result.value;
  }

  getStatDataForMonth(month: string) {
    this.statsService.getMyStatisticForMonth(this.getMonthIndex(this.currentMonth) + 1).then((stats) => {
      this.dataMonth = [];
      let dayCounter = 1;

      for (let day = 0; day < this.daysInThisMonth(); day++) {
        this.dataMonth.push({
          name: dayCounter,
          value: stats[day] || 0,
        });
        dayCounter++;
      }
    });
  }

  daysInThisMonth() {
    var now = new Date();
    return new Date(now.getFullYear(), this.getMonthIndex(this.currentMonth) + 1, 0).getDate();
  }

  previousMonth() {
    const currentMonthIndex = this.getMonthIndex(this.currentMonth);
    if (currentMonthIndex > 0) {
      this.currentMonth = this.getMonthName(currentMonthIndex - 1);
      this.updateDays();
      this.getStatDataForMonth(this.currentMonth);
    }
  }

  nextMonth() {
    const currentMonthIndex = this.getMonthIndex(this.currentMonth);
    if (currentMonthIndex < 11) {
      this.currentMonth = this.getMonthName(currentMonthIndex + 1);
      this.updateDays();
      this.getStatDataForMonth(this.currentMonth);
    }
  }

  updateDays() {
    const currentMonthIndex = this.getMonthIndex(this.currentMonth);
    const daysInMonth = new Date(new Date().getFullYear(), currentMonthIndex + 1, 0).getDate();
    this.days = Array.from({ length: daysInMonth }, (_, i) => i + 1);
  }

  updateCurrentMonth() {
    const currentDate = new Date();
    this.currentMonth = this.getMonthName(currentDate.getMonth());
    this.emptyDays = Array.from({ length: currentDate.getDay() }, (_, i) => i);
    this.updateDays();
  }

  getMonthName(monthIndex: number): string {
    const translationKey = `GENERAL.months.${monthIndex}`;
    return this.translateService.instant(translationKey);
  }

  getMonthIndex(monthName: string): number {
    // This function needs to find the index of the provided month name
    // in the current language
    for (let i = 0; i < 12; i++) {
      const translatedMonth = this.translateService.instant(`GENERAL.months.${i}`);
      if (translatedMonth === monthName) {
        return i;
      }
    }
    return 0; // Default to January if not found
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/activity-achievement/components/calender-activity.component.ts